module.exports = __webpack_public_path__ + "s18.no1.50d55d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s18.no1.jpg
// module id = eUYL
// module chunks = 0